export default {
    methods: {
        displayAndFormatTime(time, timezone, format, highLevel = false) {
            if ( _.isEmpty(time) || !moment(time).isValid()){
                if (_.isString(time)) {
                    return time;
                }
                return '';
            }
            let d = moment.utc(time);
            if (timezone && timezone !== '') {
                return d.tz(timezone).format(format);
            }

            let userTZ = 'America/Chicago';

            if (!highLevel) {
                userTZ = Intl.DateTimeFormat().resolvedOptions().timeZone;
            }
            return d.tz(userTZ).format(format);
        },
    },
}
